import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import WelcomeView from '../views/WelcomeView.vue'
import PostJobView from '../views/PostJobView.vue'
import MyJobsView from '../views/MyJobsView.vue'
import JobDetailView from '../views/JobDetailView.vue'
import ApplicantsView from '../views/ApplicantsView.vue'
import ApplyJobView from '../views/ApplyJobView.vue'
import MyApplicationsView from '../views/MyApplicationsView.vue'
import ApplicationDetailView from '../views/ApplicationDetailView.vue'

const routes = [
  { path: '/', name: 'welcome', component: WelcomeView },
  { path: '/post-job', name: 'post_job', component: PostJobView, meta: { requiresAuth: true } },
  { path: '/my-jobs', name: 'my_jobs', component: MyJobsView, meta: { requiresAuth: true } },
  { path: '/jobs/:id', name: 'job_detail', component: JobDetailView, meta: { requiresAuth: true } },
  { path: '/jobs/:id/applicants', name: 'applicants', component: ApplicantsView, meta: { requiresAuth: true } },
  { path: '/jobs/:id/apply', name: 'apply_job', component: ApplyJobView, meta: { requiresAuth: true } },
  { path: '/my-applications', name: 'my_applications', component: MyApplicationsView, meta: { requiresAuth: true } },
  { path: '/applications/:id', name: 'application_detail', component: ApplicationDetailView, meta: { requiresAuth: true } },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

router.beforeEach((to, _from, next) => {
  if (to.meta.requiresAuth && !store.getters.isAuthenticated) {
    next({ name: 'welcome' })
  } else {
    next()
  }
})

export default router
